export default __webpack_public_path__ + "static/media/people9small.5fe34169.jpg";